import { Cell } from './cell';
import { VaSwitchComponent } from '../../wrappers/va-switch/va-switch.component';
import { Switch } from '../../wrappers/va-switch/va-switch';

export class SwitchCell implements Cell {
  component = VaSwitchComponent;
  constructor(public config: Switch) {}
}
